import Eye from '@/components/Icons/Eye';
import { useState } from 'react';
import s from '@/components/Forms/TextBox.module.css';

export default function PasswordInput({
  labelCopy,
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) {
  const [showText, setShowText] = useState(false);
  const displayError = errors[field.name] && touched[field.name];
  return (
    <div className={`${s.field} ${displayError ? s.error : ''}`}>
      <input
        className={s.input}
        type={showText ? 'text' : 'password'}
        {...field}
        {...props}
      />
      <label className={s.label} htmlFor={field.name}>
        {labelCopy}
      </label>
      <Eye
        onClick={() => setShowText(!showText)}
        addClassStyles={
          field.value ? s.eye_toggle_icon_focused : s.eye_toggle_icon
        }
      />
      {displayError ? (
        <div className={s.error_copy}>{errors[field.name]}</div>
      ) : null}
    </div>
  );
}
